/**
 * Builds a Date whose local getters (`getDay`, `getHours`, `getMinutes`) match
 * the wall clock in `timeZone` at `instant`.
 *
 * Availability windows are authored in restaurant-local time; callers should
 * pass this into pagination instead of a raw UTC `Date` when a timezone is set.
 * Absolute timestamps on the returned value are not meaningful — only the
 * local calendar fields are.
 */
export function wallClockInZone(instant, timeZone) {
    if (!timeZone)
        return instant;
    try {
        const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', {
            timeZone,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hourCycle: 'h23',
            weekday: 'short',
        })
            .formatToParts(instant)
            .filter((part) => part.type !== 'literal')
            .map((part) => [part.type, part.value]));
        const year = Number(parts.year);
        const month = Number(parts.month);
        const day = Number(parts.day);
        const hour = Number(parts.hour);
        const minute = Number(parts.minute);
        const second = Number(parts.second);
        if ([year, month, day, hour, minute, second].some((n) => Number.isNaN(n))) {
            return instant;
        }
        return new Date(year, month - 1, day, hour, minute, second);
    }
    catch {
        return instant;
    }
}
//# sourceMappingURL=wall-clock.js.map